/**
 * Entry point.
 *
 * AuthProvider sits ABOVE AppProvider and outside it. `AppProvider` loads bootstrap and reference
 * data from guarded routes, so it must not mount until a session is known to exist — see root.tsx.
 * A configuration failure still renders a copyable error rather than a blank page; that handling
 * now lives one level down, inside the authenticated branch.
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { AuthProvider } from './contexts/auth_context'
import Root from './root'
import './styles.css'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Tidalfin could not start: #root is missing from index.html')
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Root />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
